module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voucher-select",
    attrs: {
      "id": "voucher-select"
    },
    on: {
      "click": function($event) {
        return _vm.open()
      }
    }
  }, [_c('ul', {
    staticClass: "list list-select"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "voucher arr-row ellipsis"
  }, [(_vm.list.length > 0) ? _c('span', {
    attrs: {
      "id": "voucherSelect-span-name"
    }
  }, [_vm._v(_vm._s(_vm._f("cardType")(_vm.list[_vm.selected].cardType)) + "/" + _vm._s(_vm.list[_vm.selected].holderName) + "/" + _vm._s(_vm._f("dotted")(_vm.list[_vm.selected].cardNo)))]) : _c('span', {
    attrs: {
      "id": "voucherSelect-span-none"
    }
  }, [_vm._v("无")])])])]), _vm._v(" "), _c('popup', {
    staticClass: "popup-select mybgcolor",
    attrs: {
      "title": '选择就诊凭证'
    },
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, _vm._l((_vm.list), function(voucher, index) {
    return _c('voucher-item-small', {
      key: index,
      class: (_vm.selected == index) ? 'selected' : 'disabled',
      attrs: {
        "id": 'voucherItem-component-' + voucher.cardNo,
        "voucher": voucher,
        "index": index
      },
      on: {
        "selected": _vm.selectVoucher
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b30a8ff","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VoucherSelect.vue
// module id = 815
// module chunks = 0